<template>
  <Spinner v-if="type === 'loading'" />

  <div v-else-if="type === 'error'" class="status error">
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
    </svg>

    {{ $t("data_error") }}
  </div>

  <div v-else-if="type === 'empty'" class="status empty">
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
    </svg>

    {{ $t("data_empty") }}
  </div>
</template>

<script>
import Spinner from "@/components/Spinner"

export default {
  name: "Status",

  components: {
    Spinner,
  },

  props: {
    type: String,
  },
}
</script>

<style scoped lang="scss">
.status {
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  padding: 1rem;
  margin: auto;

  &.error {
    color: $error;
  }

  svg {
    fill: currentColor;
    margin: 0 auto 1rem;
    display: block;
    width: 3rem;
    height: 3rem;
  }
}
</style>
